export default __webpack_public_path__ + "static/media/home-events-conference-img-18.d3ffdb59.jpg";